import React from 'react';
import { Row, Col, Table } from 'antd';
import cns from 'classnames';
import commonStyle from './common.scss';
import NormalReportTip from '../../../common/normalReportTip/NormalReportTip';
import { isNotEmpty } from '../../../../utils/util';
import {numberFixed} from '../../../../utils/formatter';

export default function CommonBus({data, title}) {
    const {moreForty, tableData} = resetData(data);
    const columns = [{ 
        title: title ? '地区名' : '产品名', 
        dataIndex: 'key'
    },
    { 
        title: '销售额', 
        dataIndex: 'val'
    }];

    return (
        <div>
            <div className="margin-bottom-10">
                {moreForty && moreForty.map(d => (
                    <NormalReportTip key={d.value + d.year} name={d.name} areaVal={d.value} year={d.year}/>
                ))}
            </div>
            <div className={commonStyle.busAreas}>
                <Row>
                    {tableData && tableData.map(item => (
                        <Col span={12} key={item.reportyear}>
                            <div>
                                <div className={cns(commonStyle.subTitle, commonStyle.borderTwo)}>{item.reportyear}</div>
                                <Table
                                    className="antdTableBT"
                                    pagination={false}
                                    bordered
                                    rowKey="key"
                                    dataSource={item.keyval}
                                    columns={columns}
                                />
                            </div>
                        </Col>
                    ))}
                </Row>
            </div>
        </div>
    );
}

// 整理数据格式
function resetData(data) {
    let moreFortyVal = [], tableData = [];
    data.forEach(item => {
        const {moreForty, filterData} = areaPort(item);
        tableData.push(filterData);
        moreFortyVal = moreFortyVal.concat(moreForty);
    });
    return {moreForty: moreFortyVal, tableData: tableData};
}

// 求出大于40%的指标
function areaPort(item) {
    let { keyval, reportyear } = item, formatterData = 0, moreForty = [], data = [];
    data = keyval.filter(d => {
        if(isNotEmpty(d.val) && d.val > 0) {
            formatterData += d.val;
            return true;
        }
        return false;
    });
    
    data.map(d => {
        let more = numberFixed((d.val / formatterData) * 100);
        if(more > 40) {
            moreForty.push({name: d.key, value: more, year: reportyear});
        }
    });
    return {moreForty: moreForty, filterData: { reportyear, keyval: data }};
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/baseInfo/common/CommonBus.jsx